<template>
  <div class="qes">
    <v-toolbar flat class="iframe-header modal_header">
      <v-img
        height="37"
        max-width="140"
        contain
        class="wallid-logo"
        src="@/assets/logo-iframe.svg"
        alt="WallID Logo"
      />
    </v-toolbar>
    <div class="qes-wrapper">
      <ErrorBanner
        :errorMsg="errorMsg"
        class="mx-3"
        style="max-width:862px !important;"
      />
      <router-view class="iframe-body" :class="errorMsg ? 'pt-3' : 'pt-7'" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import mixinQES from './QES/mixinQES';
import ErrorBanner from '@/components/ErrorBanner';

export default {
  // mixins: [mixinQES],
  components: {
    ErrorBanner,
  },
  computed: {
    ...mapGetters(['loading', 'terms', 'errorMsg']),
    step: {
      get() {
        return this.$store.state.qes.step;
      },
      set(newValue) {
        return this.$store.commit('qes/step', newValue);
      },
    },
  },
  created() {
    this.$i18n.locale = this.getBrowserLocales({ languageCodeOnly: true })[0];
  },
  mounted() {
    this.$store.commit('loading', false);

    // this.$router.push(this.ROUTE_SUCCESS);
  },
  methods: {},
};
</script>

<style lang="scss">
.qes {
  .iframe-header {
    position: absolute;
    width: 100%;
  }
  .qes-wrapper {
    overflow: auto;
    margin-top: 56px;
  }
  .iframe-body {
    padding: 12px;
    max-width: 898px !important;
    max-height: 80vh;
    overflow: auto;
  }
  .iframe-header {
    padding: 0;
    padding-bottom: 12px;
    padding-left: 24px;
    .v-toolbar__content {
      padding: 0;
    }
  }
  .iframe-footer {
    .v-btn.button-iframe {
      min-width: 96px;
      margin-left: 12px;
      &.back {
        background: none;

        .v-btn__content {
          font-size: 15px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.6;
          letter-spacing: normal;
          color: #373c43;
        }
      }
      &.advance {
        border-radius: 4px;
        background-color: #009fb1;
      }
      &.v-btn--disabled {
        background-color: #86c2c9;
      }
      &.v-btn--loading {
        color: white;
      }
      .v-btn__content {
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        text-transform: none;
      }
    }
  }
  h1 {
    font-family: Montserrat;
    font-size: 26px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #373c43;
  }
  p,
  .link-inline,
  .terms-checkbox label {
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: #373c43;
  }

  .link-inline,
  .terms-checkbox {
    &.disable {
      .v-input--selection-controls__input,
      .v-label {
        pointer-events: none;
      }
    }
    a {
      color: #009fb1;
      text-decoration: none;
      &:hover {
        color: #01a3b0;
      }
    }
  }
  .form-field {
    .error-fields,
    .error-fields .v-input__slot {
      border-color: var(--coral) !important;
    }
    p.error-fields {
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: var(--coral);
      margin-top: 6px;
    }
    .label-form {
      font-size: 15px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: var(--charcoal-grey);
      margin-bottom: 12px;
      display: block;
    }
    .password-input {
      .v-input__control {
        min-height: unset;
        .v-input__slot {
          padding: 0 20px;
          border-radius: 5px;
          border: solid 1px #cbcbcb;
          input,
          input::placeholder {
            margin: 5px 0;
            font-size: 14px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.14;
            letter-spacing: normal;
            color: var(--charcoal-grey);
          }
        }
      }
      &.v-input--is-focused {
        .v-input__slot {
          border: solid 1px var(--teal-blue);
        }
      }
    }
  }
  .Shape {
    width: 14px;
    height: 14px;
    object-fit: contain;
    vertical-align: initial;
  }
}
</style>
